import { AcornsIcon } from '@acorns/icons'
import styled from 'styled-components'

import { style } from 'theme'

export const StyledCashOwedBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  background-color: rgba(240, 167, 99, 0.1);
  border-radius: 10px;
  width: 450px;
  height: 52px;
  padding: 15px 20px;
  cursor: pointer;

  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    width: 85%;
    margin-left: 30px;
    margin-right: 30px;
  }
`

export const StyledInfoIcon = styled(AcornsIcon)`
  margin-left: 5px;
  margin-bottom: -1px;
  cursor: pointer;
`
